// extracted by extract-css-chunks-webpack-plugin
module.exports = {"textarea":"_1IxPTj","default":"_18lhtm","fullWidth":"_1yOlb8","noResize":"_1Saurw"};